/**
 * Dates for the thought for today.
 *
 * The thought is picked by the student's LOCAL date, so it turns at their
 * midnight. The rotation mirrors `rotation_index` in
 * `backend/src/wellbeing/thoughts.py` (Python's `date.toordinal()`), which is
 * what lets mock mode pick the same thought the server would for a date.
 */

/** `2026-10-01`, local time: today's, by the clock on the wall. */
export function localDateKey(now: number): string {
  const d = new Date(now);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}

// `date(1970, 1, 1).toordinal()`.
const EPOCH_ORDINAL = 719_163;
const DAY_MS = 86_400_000;

/** Which of `count` thoughts `dateKey` gets; consecutive days, consecutive thoughts. */
export function rotationIndex(dateKey: string, count: number): number {
  const [y, m, d] = dateKey.split('-').map(Number);
  const ordinal = Date.UTC(y, m - 1, d) / DAY_MS + EPOCH_ORDINAL;
  return ordinal % count;
}
